import { CredentialsService } from '@app/core/authentication/credentials.service';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

/**
 * Prefixes all requests not starting with `http[s]` with `environment.serverUrl`.
 */
import { UntilDestroy } from '@ngneat/until-destroy'
import { I18nService } from '../i18n.service';
 @UntilDestroy()
 @Injectable({
   providedIn: 'root'
 })
 export class ApiPrefixInterceptor implements HttpInterceptor {
   constructor(private credentialsService: CredentialsService, private i18nService: I18nService) {}
   intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
     if (!/^(http|https):/i.test(request.url)) {
       request = request.clone({
         url: environment.serverUrl + environment.apiVersion + request.url
       });
       if (this.credentialsService.token) {
         request = request.clone({
           headers: request.headers.append('Authorization', 'Bearer ' + this.credentialsService.token)
         });
       }
       if (this.i18nService.language) {
         request = request.clone({
           headers: request.headers.append('X-LOCALE', this.i18nService.language)
         });
       }
     }
     return next.handle(request);
   }
 }
